export default __webpack_public_path__ + "static/luis-manuel-hernandez-aguilar-5c90a59a679097b63842f40574e3f79f.png";